/**
 * ManagerName - [Phase 2a.2-B §4.4 R13]
 *
 * Renders a manager/team name with a 🤖 badge prefix when the underlying
 * user has is_bot=true.
 *
 * Usage:
 *   <ManagerName name="The Burner Phones" isBot={team.is_bot} />
 *   <ManagerName name={u.first_name} isBot={u.is_bot} testId="dash-manager-1" />
 *
 * Falls back gracefully when isBot is missing (renders just the name).
 */
import { Bot } from "lucide-react";

export default function ManagerName({ name, isBot, className = "", testId, iconSize = 11 }) {
  return (
    <span className={`inline-flex items-center gap-1 ${className}`} data-testid={testId}>
      {isBot && (
        <Bot
          size={iconSize}
          className="text-[#A0A0A0] shrink-0"
          aria-label="CPU manager"
          data-testid={testId ? `${testId}-bot-badge` : "manager-bot-badge"}
        />
      )}
      <span className="truncate">{name || "-"}</span>
    </span>
  );
}
